"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _modalLoader = require("@wsb/modal-loader");
var namespace = 'dify-lead-gen';
var loaderConfig = {
  appConfigKey: namespace,
  // appProps: PropTypes.object,
  // cdnBaseUrl: 'https://img1.wsimg.com',
  cdnVirtualPath: "blobby/go/static/engagement/".concat(namespace),
  // deps,
  // errorComponent: DefaultError,
  hasBundledCss: true,
  // i18nPath: 'i18n',
  // i18nVersionKey: PropTypes.string,
  // loaderComponent: DefaultLoader,
  // market: PropTypes.string,
  namespace: namespace,
  // onReactError: PropTypes.func,
  // onWindowError: PropTypes.func,
  renderMode: _modalLoader.RenderMode.MODAL,
  // rootDomain: PropTypes.string,
  // versionEnvKey: 'SOCIAL_SHARE_LIVE_VERSION',
  versionKey: 'difyLeadGenLiveVersion'
  // versionParam: 'wdhLiveVersion'
};
var _default = exports["default"] = loaderConfig;